import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change so each page starts at the top of the canvas.
// Shared-element morph (Shop card → PDP cover) is handled by Framer Motion's
// LayoutGroup; it captures source/target rects during the same render frame,
// so this useEffect-based scroll runs harmlessly afterwards.
export const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

export default ScrollToTop;
